<template>
  <div>
    <baseFrame
      save-text=""
      clear-text=""
      submit-text="提交"
      :submit-loading="submitLoading"
      @submit="submitConfirm"
      @cancel="handleToList">
      <div slot="content">
        <lk-card>
          <lk-form
            ref="form"
            label-position="right"
            :model="formModel"
            :label-width="134">
            <lk-row :gutter="16">
              <lk-col span="23">
                <lk-form-item label="时间修改明细:">
                  <lk-button type="primary" @click="handleAdd">新增</lk-button>
                  <span class="red"> 修改单据的创建时间、最终审核通过时间可能影响财务报表期初数据，请务必获得财务人员确认后再修改！</span>
                </lk-form-item>
              </lk-col>
            </lk-row>
            <lk-row :gutter="16">
              <lk-col span="23">
                <div class="" style="margin-left: 134px;">
                  <lk-table border :columns="columns" :data="formModel.tableData">
                    <template slot-scope="{ row, index }" slot="bizType">
                      <lk-form-item
                        :prop="'tableData.' + index + '.bizType'"
                        :label-width="0"
                        :rules="[ { required: true, message: '请选择...' },]">
                        <lk-select
                          clearable
                          transfer
                          placeholder="请选择"
                          v-model="row.bizType"
                          @on-change="validFormItem($event, row, index, 1)"
                          class="item">
                          <lk-option v-for="(item) in chageTypeList" :key="item.value" :value="item.value">{{item.name}}</lk-option>
                        </lk-select>
                      </lk-form-item>
                    </template>
                    <template slot-scope="{ row, index }" slot="realCreateTime">
                      <lk-form-item
                        :prop="'tableData.' + index + '.realCreateTime'"
                        :label-width="0"
                        :rules="formRules">
                        <timeStampDatePicker
                          class="item"
                          transfer
                          placeholder="请选择"
                          v-model.trim="row.realCreateTime"
                          @on-change="validFormItem($event, row, index, 2)">
                        </timeStampDatePicker>
                      </lk-form-item>
                    </template>
                  </lk-table>
                </div>
              </lk-col>
            </lk-row>
          </lk-form>
        </lk-card>
      </div>
    </baseFrame>
    <DTPModal
      v-model="submitConfirmVisiable"
      content="单据类型或时间被修改，确认提交？"
      :confirmLoading="submitLoading"
      @confirm="submit"
      @handleCancel="submitConfirmVisiable = false">
    </DTPModal>
    <lk-modal
      v-model="modalVisiable"
      :mask-closable="false"
      title="选择商品"
      width="900">
      <div class="queryContainer">
        <div class="queryItem">
          <label>单据类型：</label>
          <lk-select
            class="item"
            placeholder="请选择"
            v-model.trim="modalQuery.type">
            <lk-option v-for="(item) in bizTypeList" :key="item.value" :value="item.value">{{item.name}}</lk-option>
          </lk-select>
        </div>
        <div class="queryItem">
          <label>单据号：</label>
          <lk-input class="item" v-model.trim="modalQuery.orderNo" placeholder="请输入"></lk-input>
        </div>
        <div class="queryItem">
          <lk-button type="primary" class="mr8" @click="handleModalSearch">查询</lk-button>
          <lk-button @click="clearModalQuery" class="mr8">重置</lk-button>
        </div>
      </div>
      <div style="position: relative;">
        <LoadingSpan v-show="modalLoading"></LoadingSpan>
        <lk-table
          border
          height="400"
          :columns="modalColumns"
          :data="modalTableData"
          @on-select="handleTempSelect"
          @on-select-cancel="handleTempCancel"
          @on-select-all="handleSelectAll"
          @on-select-all-cancel="handleSelectAllCancel">
        </lk-table>
      </div>
      <div style="margin-top: 14px; text-align: right;">
        <lk-page
          :total="modalPage.count"
          :page-size="modalPage.size"
          :current="modalPage.page"
          size="small"
          show-sizer
          show-total
          show-elevator
          @on-change="handleModalPage"
          @on-page-size-change="handleModalSize">
        </lk-page>
      </div>
      <div slot="footer">
        <div class="queryItem">
          <span style="padding-right: 16px;">已选:{{this.tempSelection.length + this.formModel.tableData.length}}项</span>
          <lk-button @click="hideModal">取消</lk-button>
          <lk-button type="primary" class="mr" @click="pushModalData">确定</lk-button>
        </div>
      </div>
    </lk-modal>
  </div>
</template>
<script>
import baseFrame from '../../components/frame/BaseFrame.vue';
import toolsService from '../../services/tools';
import toolsGoodsMixins from '../../mixins/toolsGoodsMixins';
import goodsService from '../../services/goods';
import utils from '../../libs/utils';
import DTPModal from '../../components/DTPModal';
import LoadingSpan from '../../components/LoadingSpan.vue';

export default {
  name: 'outputTaxRateAdd',
  mixins: [toolsGoodsMixins],
  components: {
    baseFrame,
    DTPModal,
    LoadingSpan,
  },
  data() {
    return {
      formModel: {
        tableData: [],
      },
      formRules: [
        { required: true, message: '请选择...' },
      ],
      bizTypeList: [
        {
          value: 1,
          name: '销售订单',
        },
        {
          value: 2,
          name: '销售退货单',
        },
        {
          value: 3,
          name: '验收单',
        },
        {
          value: 4,
          name: '供应商退货单',
        },
        {
          value: 5,
          name: '应付单',
        },
        {
          value: 6,
          name: '采购计划单',
        },
        {
          value: 7,
          name: '采购订单',
        },
        {
          value: 8,
          name: '收货单',
        },
      ],
      chageTypeList: [
        {
          value: 1,
          name: '创建',
        },
        {
          value: 2,
          name: '审核',
        },
      ],
      submitConfirmVisiable: false,
      submitLoading: false,
      columns: [
        { title: '单据号', key: 'bizNo', minWidth: 116 },
        {
          title: '门店名称',
          key: 'storeName',
          minWidth: 130,
        },
	      {
	      	title: '修改类型',
          slot: 'bizType',
          minWidth: 116,
        },
	      {
	      	title: '原时间',
          key: 'createTime',
          minWidth: 116,
        },
	      {
		      title: '修改后时间',
		      slot: 'realCreateTime',
		      minWidth: 116,
	      },
        {
          title: '规格',
          key: 'specifications',
          minWidth: 116,
        },
        { title: '生产企业', key: 'manufacturer', minWidth: 116 },
        {
          title: '操作',
          key: 'action',
          fixed: 'right',
          width: 130,
          render: (h, { index }) => h('lk-button', {
            props: {
              type: 'text',
            },
            on: {
              click: () => {
                this.formModel.tableData.splice(index, 1);
                this.$Message.success('删除成功');
                this.$nextTick(() => {
                  this.$refs.form.validate();
                });
              },
            },
          }, '删除'),
        },
      ],
      modalColumns: [
        {
          title: '选择', key: 'id', type: 'selection', width: 60,
        },
        { title: '单据类型', key: 'bizTypeName', minWidth: 116 },
        { title: '单据号', key: 'orderNo', minWidth: 156 },
        { title: '门店名称', key: 'storeName', minWidth: 156 },
      ],
    };
  },
  computed: {
  },
  methods: {
    handleToList() {
      this.$router.push({
        name: 'billsTimeAdd',
      });
    },
    validSingleItemByIndex(type, index) {
      if (type === 1) {
        this.$refs.form.validateField(`tableData.${index}.bizType`);
      } else {
        this.$refs.form.validateField(`tableData.${index}.realCreateTime`);
      }
    },
    validFormItem(value, item, index, type) {
      this.formModel.tableData[index] = item;
      this.$nextTick(() => {
        if (utils.isEmpty(value)) { // 重新触发验证
          this.validSingleItemByIndex(type, index);
        }
      });
    },
    getModalData() {
      this.modalParams.page = this.modalPage.page;
      this.modalParams.size = this.modalPage.size;
      this.$store.commit('setDisableLoading', true);
      this.modalLoading = true;
      goodsService.listGoodsBases(this.modalParams).then((res) => {
        if (res.data.status === 200) {
          const { count, list } = res.data.data;
          this.modalTableData = [];
          list.forEach((item) => {
            const result = this.exchangeGoodsBase(item);
            result._checked = this.selectedIds.includes(result.id) || this.tempSelectionIds.includes(result.id);
            result._disabled = this.selectedIds.includes(result.id);
            result.bizType = result.bizType || '';
            this.modalTableData.push(result);
          });
          this.modalPage.count = count;
        } else {
          this.$Message.error(res.data.error);
        }
        this.modalLoading = false;
      }).catch((err) => {
        this.modalLoading = false;
        utils.handleError(err);
      });
    },
    submit() {
      const params = [];
      this.formModel.tableData.forEach((item) => {
        params.push({
          goodsBaseId: item.originGoodsBaseId,
			    bizType: item.bizType,
          approvedName: item.approvedDrugNames,
          spec: item.specifications,
          producer: item.manufacturer,
          origin: item.countryOfOrigin,
          goodsType: item.type,
        });
      });
      this.submitLoading = true;
      this.$store.commit('setDisableLoading', true);
      toolsService.outputTaxRateUpdateSubmit({ operateGoodsKeyVoList: params }).then((res) => {
        if (res.data.status === 200) {
          this.$Message.success('提交成功');
          setTimeout(() => {
            this.handleToList();
          }, 1000);
        } else {
          this.$Message.error(res.data.error);
        }
        this.submitConfirmVisiable = false;
        this.submitLoading = false;
      }).catch((err) => {
        this.submitConfirmVisiable = false;
        this.submitLoading = false;
        utils.handleError(err);
      });
    },
    submitConfirm() {
      if (this.formModel.tableData.length === 0) {
        this.$Message.error('请先添加明细');
        return;
      }

      this.$refs.form.validate((valid) => {
        if (valid) {
          this.submitConfirmVisiable = true;
        } else {
          this.$Message.error('请按照要求填写');
        }
      });
    },
  },
  created() {},
};
</script>
<style lang="less" scoped>
  .red {
    color: red;
  }
</style>
